// removed by extract-text-webpack-plugin
module.exports = {"headerTitle":"_2s2RylqAUVJaCdkmtL30lX","socialNetworks":"_1Ql9u4An8zOmfuGaKqCach","socialNetworksItem":"_3b8pvbvSB-BhwgppP77sDS","iconItem":"_3_p3_Yxeiws6Bv3KqO4gfr"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/contact/contact.css
// module id = 117
// module chunks = 0